import React from 'react';

import { AdminLayout, getIntFromString } from '../../look';
import ROUTE from '../route';

import VerticalFormComponent from './VerticalFormComponent';

const EditVerticalView = props => {
  return (
    <AdminLayout
      table={false}
      active={ROUTE.vertical}
      title="Edit vertical"
      backLink={`${ROUTE.verticalDetailLink}${
        props.verticalByVerticalId && getIntFromString(props.verticalByVerticalId.id)
      }`}
      FormComponent={props.verticalByVerticalId && <VerticalFormComponent {...props} />}
    />
  );
};

export default EditVerticalView;
